export const icons = {
    empty: 'assets/img/star-empty.svg',
    half: 'assets/img/star-full.svg',
    full: 'assets/img/star-full.svg',
}
